import Flickity from 'flickity';

document.addEventListener('DOMContentLoaded', () => {
  const logosLists = document.querySelectorAll('.js-logos-list');

  if (logosLists && logosLists.length > 0) {
    for (let i = 0; i < logosLists.length; i += 1) {
      const carousel = new Flickity(
        logosLists[i].querySelector('.logos-list-carousel-cards'),
        {
          setGallerySize: false,
          cellAlign: 'center',
          contain: true,
          groupCells: true,
          prevNextButtons: true,
          pageDots: false,
          autoPlay: false,
          lazyLoad: false,
        },
      );
    }
  }
});
